import moment from "moment";
import "redux-form";
import {FormAction} from "redux-form/lib/actions";
import {ACTIONS} from "Redux/Actions/LatestDataframesForm.Actions";
import * as ActionTypes from "Redux/Actions/EnumTypes/ActionEnumTypes";

export interface LatestDataframesFormState {
  startDate: moment.Moment
  endDate: moment.Moment
  fullTrace: boolean
}

const initialState: LatestDataframesFormState  = {
  startDate: null,
  endDate: null,
  fullTrace: false
}

export function latestDataframesFormReducer(state = initialState, action: FormAction) {
  switch (action.type) {
    case ACTIONS.UPDATE_DATE_RANGE:
    case ActionTypes.History.GET_LATEST_DATAFRAMES_SUCCESS: {
      if (!action.payload.formData) {
        return initialState
      }

      return {
        ...state,
        startDate: action.payload.formData.startDate,
        endDate: action.payload.formData.endDate,
        fullTrace: !!action.payload.formData.fullTrace,
      }
    }
    default: {
      return state
    }
  }
}



// WEBPACK FOOTER //
// ./src/Redux/Reducers/LatestDataframesForm.Reducer.ts